import classes from './Button.module.scss';
import Link from 'next/link';
import Image from 'next/image';

export default function Button({ data }) {
    const { url, label, style, isExternal, iconPath } = data;

    /**
     * return null needed for Next.js link validation
     */
    if (!url) return null;

    return (
        <Link href={url}>
            <a
                className={`${classes.aBtn} ${classes[`${style}`]}`}
                rel="noopener"
                target={isExternal}
                role="link"
            >
                {iconPath?.length > 0 && (
                    <figure className={classes.mIcon}>
                        <Image src={iconPath} alt="arrow" width={16} height={16} layout="fixed" />
                    </figure>
                )}
                <span className={classes.aText}>{label}</span>
            </a>
        </Link>
    );
}
